export default __webpack_public_path__ + "static/media/kanta_identification.d17692ee.png";